import { AnyAction } from 'redux';
import { GlobalActions, SpeichernStatus, VermerkInfo } from '@ps20-frontend/shop-integration-redux';
import { Speichern } from '../interfaces/speichern';
import { ToolbarActions } from '../toolbar.actions';

export const speichernReducer = function (
  sectionState: Speichern = null,
  action: AnyAction,
): Speichern {
  switch (action.type) {
    case ToolbarActions.SPEICHER_STATUS_CHANGED: {
      return { ...sectionState, speicherStatus: action.payload };
    }
    case GlobalActions.TOGGLE_MODAL: {
      const newSpeichern = {
        ...sectionState,
        speicherModalOpen: action.payload,
      };
      return { ...sectionState, ...newSpeichern };
    }
    case GlobalActions.SAVE_STATUS_RECEIVED: {
      const speichern: SpeichernStatus = action.payload;
      if (speichern.status === 200) {
        const newSpeichern = {
          ...sectionState,
          saveAsCopy: false,
          speicherStatus: 'success',
        };
        return { ...sectionState, ...newSpeichern };
      } else {
        const newSpeichern = { ...sectionState, speicherStatus: 'fail' };
        return { ...sectionState, ...newSpeichern };
      }
    }
    case ToolbarActions.VERMERK_CHANGED: {
      const isManual: boolean = action.payload !== '';
      const newSpeichern = {
        ...sectionState,
        vermerk: action.payload,
        vermerkManualInput: isManual,
      };
      return { ...sectionState, ...newSpeichern };
    }
    case ToolbarActions.SAVE_AS_COPY_SELECTED: {
      const newSpeichern = {
        ...sectionState,
        saveAsCopy: action.payload,
      };
      return { ...sectionState, ...newSpeichern };
    }
    case GlobalActions.VERMERK_INIT: {
      if (!sectionState.vermerkManualInput) {
        const vermerkInfos: VermerkInfo[] = action.payload;
        const currencyOptions: Intl.NumberFormatOptions = {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'code',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        };
        const vermerk = vermerkInfos
          .map(
            info =>
              info.sparte +
              (info.beitrag
                ? ' ' +
                  info.beitrag.toLocaleString('de-DE', currencyOptions).replaceAll(/\u00a0/g, ' ')
                : ''),
          )
          .join(', ');
        return { ...sectionState, vermerk: vermerk };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
